var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var safePatches = function (patches) {
    return patches.map(function (p) { return (__assign(__assign({}, p), { inputs: p.inputs || [], outputs: p.outputs || [] })); });
};
/** find a patch in the patchwork with an edge id */
export var findPatch = function (edgeId, patchwork) {
    var edge = patchwork.edges.find(function (p) { return p.id === edgeId; });
    if (edge) {
        return patchwork.patches.find(function (p) { return p.id === edge.to_patch; }) || null;
    }
    return null;
};
/** find a patch's index value in the patchwork with an edge id */
export var findPatchIndex = function (edgeId, patchwork) {
    var edge = patchwork.edges.find(function (p) { return p.id === edgeId; });
    if (edge) {
        return patchwork.patches.find(function (p) { return p.id === edge.to_patch; }) || -1;
    }
    return -1;
};
